<template>
  <section class="select-demand-seriousness">
    <HSelect
      label="Gravidade (opcional)"
      aria-label="Gravidade"
      :options="seriousnessType"
      placeholder="Selecione na lista"
      :value="seriousness"
      option-key="label"
      option-label="label"
      @update:value="handleSeriousness"
    />
  </section>
</template>

<script>
import { CONDITION_SERIOUSNESS_OPTIONS } from '@/models/demands'
import Logger, { EventModel, EventName } from '@/wrappers/logger'

import { HSelect } from '../../atoms'

export default {
  components: { HSelect },
  props: {
    demand: {
      type: Object,
      required: true
    }
  },
  emits: ['input'],
  data() {
    return {
      seriousnessType: CONDITION_SERIOUSNESS_OPTIONS
    }
  },
  computed: {
    seriousness() {
      return CONDITION_SERIOUSNESS_OPTIONS.find(
        it => it.value === this.demand?.seriousness
      )
    }
  },
  methods: {
    handleSeriousness({ value }) {
      Logger.addLog(EventName.USER_INTERACTION_FORM, {
        model: EventModel.APPOINTMENT,
        data: {
          context: 'add-demand-widget',
          action: 'select-seriousness'
        }
      })
      this.$emit('input', value)
    }
  }
}
</script>
